export type BillingTier = 'free' | 'core' | 'pro' | 'premium';

export type PlanId = 'free' | 'core' | 'pro' | 'premium';

const BILLING_TIER_ORDER: BillingTier[] = ['free', 'core', 'pro', 'premium'];

export function resolveBillingTier(roles: string[] | null | undefined): BillingTier {
  const upper = (roles ?? []).map((role) => role.toUpperCase());

  if (upper.some((role) => role.includes('PREMIUM'))) {
    return 'premium';
  }

  if (upper.some((role) => role.includes('PRO'))) {
    return 'pro';
  }

  if (upper.some((role) => role.includes('CORE'))) {
    return 'core';
  }

  return 'free';
}

export function billingTierLabel(tier: BillingTier): string {
  switch (tier) {
    case 'core':
      return 'Core';
    case 'pro':
      return 'Pro';
    case 'premium':
      return 'Premium';
    default:
      return 'Free';
  }
}

/** Paid plan IDs strictly above the user's current tier (empty when already Premium). */
export function upgradePlanIds(currentTier: BillingTier): PlanId[] {
  const currentIndex = BILLING_TIER_ORDER.indexOf(currentTier);
  return BILLING_TIER_ORDER.slice(currentIndex + 1) as PlanId[];
}

export function isUpgradePlan(planId: PlanId, currentTier: BillingTier): boolean {
  return upgradePlanIds(currentTier).includes(planId);
}
